import { createSlice } from "@reduxjs/toolkit";
import { SliceAction } from "store/store";

const initialState: {
    activePaginationPage: number
} = {
    activePaginationPage: 1
};

const promoCodesSlice = createSlice({
    initialState,
    name: "promoCodesAdminPage",
    reducers: {
        setActivePaginationPage(state, action: SliceAction<number>) {
            state.activePaginationPage = action.payload;
        },
    },
});

const { reducer, actions } = promoCodesSlice;

export default reducer;

export const {
    setActivePaginationPage
} = actions;
